




























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
@Component
export default class Presenca extends Vue {
  clientes: any = [];
  clientes1: any = [];
  clientes2: any = [];
  clientes3: any = [];
  mounted() {
    this.clientes = [
      {
        title: "FIAT - Córdoba - AR",
        src: require("../assets/img/clientes/FIAT-Cordoba.png"),
      },
      {
        title: "FIAT - Betim - MG",
        src: require("../assets/img/clientes/FIAT-Betim.png"),
      },
       {
        title: "FIAT - Campo Largo - PR",
        src: require("../assets/img/clientes/FIAT-Parana.png"),
      },
      {
        title: "FIAT - Goiana - PE",
        src: require("../assets/img/clientes/Jeep.png"),
      },
      {
        title: "Instituto Ayrton Senna - SP",
        src: require("../assets/img/clientes/IAS.png"),
      },
      {
        title: "Sistema de Informações da Educação de Pernambuco - PE",
        src: require("../assets/img/clientes/SIEPE.png"),
      },
      {
        title: "Sistema Educacional do Ipojuca - PE",
        src: require("../assets/img/clientes/SEI.png"),
      },
       {
        title: "Sistema Educacional de Betim - MG",
        src: require("../assets/img/clientes/betim.png"),
      },
      {
        title: "Sistema Educacional de Ibirité - MG",
        src: require("../assets/img/clientes/ibirite.png"),
      },
      {
        title: "Sistema de Gestão Educacional de Nova Iguaçu - RJ",
        src: require("../assets/img/clientes/novaiguacu.png"),
      },
       {
        title: "Sistema de Gestão Educacional de Duque de Caxias - RJ",
        src: require("../assets/img/clientes/duquedecaxias.png"),
      },
      {
        title: "Sistema de Gestão Educacional de Barra Mansa - RJ",
        src: require("../assets/img/clientes/barramansa.png"),
      },
      {
        title: "Sistema de Gestão Educacional - Santa Cruz Cabrália - BA",
        src: require("../assets/img/clientes/cabralia.png"),
      },
      {
        title: "Sistema de Informações Educacionais de Caruaru - PE",
        src: require("../assets/img/clientes/caruaru.png"),
      },
       {
        title: "Sistema de Informações Educacionais de Olinda - PE",
        src: require("../assets/img/clientes/olinda.png"),
      },
      {
        title: "Sistema de Educação de Esmeraldas - MG",
        src: require("../assets/img/clientes/Esmeraldas.png"),
      },
       {
        title: "Sistema Educacional de São Bento do Una - PE",
        src: require("../assets/img/clientes/UNA-SE.png"),
      },
      {
        title: "Sistema de Gestão Educacional de Guiricema - MG",
        src: require("../assets/img/clientes/guiricema.png"),
      },
      {
        title: "Sistema Educacional de Chã Grande - PE",
        src: require("../assets/img/clientes/chagrande.png"),
      },
      {
        title: "Sistema Educacional de Barão de Cocais - MG",
        src: require("../assets/img/clientes/barao.png"),
      },
      {
        title: "Sistema de Gestão Educacional do Cabo de Santo Agostinho - PE",
        src: require("../assets/img/clientes/cabo.png"),
      },
      {
        title: "Sistema de Informação Educacional de Belo Jardim - PE",
        src: require("../assets/img/clientes/belojardim.png"),
      },
      {
        title: "Sistema de Gestão Educacional de Pombos - PE",
        src: require("../assets/img/clientes/pombos.png"),
      }, 
      {
        title: "Gestão Educacional de Moreno - PE",
        src: require("../assets/img/clientes/moreno.png"),
      },
      {
        title: "Inspetoria Madre Mazzarello - MG",
        src: require("../assets/img/clientes/IMM.png"),
      },
      {
        title: "Escola de Formação Gerencial - Contagem - MG",
        src: require("../assets/img/clientes/EFG.png"),
      },
      {
        title: "Instituto Histórico e Geográfico de Minas Gerais - MG",
        src: require("../assets/img/clientes/IHG-MG.png"),
      },
      {
        title: "Programa de Informação da Gestão - Petrolina - PE",
        src: require("../assets/img/clientes/PROIG.png"),
      },
      {
        title: "Sistema Educacional de Araruama - RJ",
        src: require("../assets/img/clientes/araruama.png"),
      },
      {
        title: "Instituto de Tecnologia de Pernambuco - PE",
        src: require("../assets/img/clientes/ITEP.png"),
      },
    ];
    this.clientes1 = [
      {
        title: "Sistema de Educação de Licínio de Almeida - BA",
        src: require("../assets/img/clientes/Licinio Almeida.png"),
      },
      {
        title: "Centro Educacional Maria Auxiliadora - DF",
        src: require("../assets/img/clientes/CEMA.png"),
      },
      {
        title: "Colégio Auxilium - GO",
        src: require("../assets/img/clientes/Auxilium.png"),
      },
      {
        title: "Colégio Pio XII - MG",
        src: require("../assets/img/clientes/PioXII.png"),
      },
      {
        title: "Escola Nossa Senhora Auxiliadora - MG",
        src: require("../assets/img/clientes/ENSA.png"),
      },
      {
        title: "Insituto Auxiliadora - Silvânia - GO",
        src: require("../assets/img/clientes/Auxiliadora-Silvania.png"),
      },
      {
        title: "Instituto Auxiliadora - São João Del Rey - MG",
        src: require("../assets/img/clientes/Auxiliadora-SJDR.png"),
      },
      {
        title: "Instituto Maria Auxiliadora - GO",
        src: require("../assets/img/clientes/IMA.png"),
      },
      {
        title: "Instituto Maria Imaculada - MG",
        src: require("../assets/img/clientes/IMI.png"),
      },
      {
        title: "Instituto Teresa Valsé - MG",
        src: require("../assets/img/clientes/ITV.png"),
      },
      {
        title: "Patronato Madre Mazzarello - GO",
        src: require("../assets/img/clientes/Patronato.png"),
      },
      {
        title:
          "AMFRI - Associação Dos Municipios da Região Foz do Rio Itajaí - SC",
        src: require("../assets/img/clientes/itajai.jpg"),
      },
      {
        title:
          "Secretaria de Estado da Educação Cultura e Desporto de Roraima - RR",
        src: require("../assets/img/clientes/roraima.jpg"),
      },
      {
        title: "Prefeitura da Cidade do Rio de Janeiro - RJ",
        src: require("../assets/img/clientes/rio.jpg"),
      },
      {
        title: "Prefeitura do Jaboatão Dos Guararapes - PE",
        src: require("../assets/img/clientes/jaboatao.jpg"),
      },
      {
        title: "Prefeitura Municipal de Altamira - PA",
        src: require("../assets/img/clientes/altamira.jpg"),
      },
      {
        title: "Prefeitura Municipal de Caxias do Sul - RS",
        src: require("../assets/img/clientes/caxiasdosul.jpg"),
      },
      {
        title: "Prefeitura Municipal de Diadema - SP",
        src: require("../assets/img/clientes/diadema.jpg"),
      },
      {
        title: "Prefeitura Municipal de Itajaí - SC",
        src: require("../assets/img/clientes/itajai.jpg"),
      },
      {
        title: "Prefeitura Municipal de Joinville - SC",
        src: require("../assets/img/clientes/joinville.jpg"),
      },
      {
        title: "Prefeitura Municipal de Manaus - AM",
        src: require("../assets/img/clientes/manaus.jpg"),
      },
      {
        title: "Prefeitura Municipal de Marília - SP",
        src: require("../assets/img/clientes/marilia.jpg"),
      },
      {
        title: "Prefeitura Municipal de Mossoró - RN",
        src: require("../assets/img/clientes/mossoro.jpg"),
      },
      {
        title: "Prefeitura Municipal de Parnaíba - PI",
        src: require("../assets/img/clientes/parnaiba.jpg"),
      },
      {
        title: "Prefeitura Municipal de Pinhais - PR",
        src: require("../assets/img/clientes/pinhais.jpg"),
      },
      {
        title: "Prefeitura Municipal de Ponta Grossa - PR",
        src: require("../assets/img/clientes/pontagrossa.jpg"),
      },
      {
        title: "Prefeitura Municipal de Santarém - PA",
        src: require("../assets/img/clientes/santarem.jpg"),
      },
      {
        title: "Prefeitura Municipal de São José do Rio Preto - SP",
        src: require("../assets/img/clientes/saojoseriopreto.jpg"),
      },
      {
        title: "Prefeitura Municipal de São José Dos Pinhais - PR",
        src: require("../assets/img/clientes/saojosepinhais.jpg"),
      },
      {
        title: "Prefeitura Municipal de São Mateus - ES",
        src: require("../assets/img/clientes/saomateus.jpg"),
      },
      {
        title: "Prefeitura Municipal de Sao Vicente - SP",
        src: require("../assets/img/clientes/saovicente.jpg"),
      },
      {
        title: "Prefeitura Municipal de Sobral - CE",
        src: require("../assets/img/clientes/sobral.jpg"),
      },
      {
        title: "Prefeitura Municipal de Teresina - PI",
        src: require("../assets/img/clientes/teresina.jpg"),
      },
      {
        title:
          "Serviço Apoio Micro e Pequenas Empresas de São Paulo - Sebrae - SP",
        src: require("../assets/img/clientes/sebrae.jpg"),
      },
      {
        title: "Secretaria da Educação e Cultura do Estado do Piauí - PI",
        src: require("../assets/img/clientes/piaui.jpg"),
      },
      {
        title: "Secretaria da Educ. e Cultura do Tocantins - TO",
        src: require("../assets/img/clientes/tocantins.jpg"),
      },
      {
        title: "Secretaria de Educação do Estado de Sergipe - SE",
        src: require("../assets/img/clientes/sergipe.jpg"),
      },
      {
        title: "Secretaria da Educação e Cultura da Paraíba - PB",
        src: require("../assets/img/clientes/paraiba.jpg"),
      },
      {
        title: "Secretaria de Educação de Mato Grosso - MT",
        src: require("../assets/img/clientes/matogrosso.jpg"),
      },
      {
        title: "Secretaria de Estado da Educação do Rio Grande do Sul - RS",
        src: require("../assets/img/clientes/riograndedosul.jpg"),
      },
      {
        title: "Secretaria de Estado da Educação de Rondônia - RO",
        src: require("../assets/img/clientes/rondonia.jpg"),
      },
      {
        title: "Secretaria Municipal de Educação Araguaína - TO",
        src: require("../assets/img/clientes/araguaina.jpg"),
      },
      {
        title: "APERAM (Cia. Aços Especiais Itabira - ACESITA) - MG",
        src: require("../assets/img/clientes/aperam.jpg"),
      },
      {
        title: "Companhia de Saneamento de Minas Gerais - Copasa - MG",
        src: require("../assets/img/clientes/copasa.jpg"),
      },
      {
        title: "Zurich (Companhia de Seguros Minas Brasil) - MG",
        src: require("../assets/img/clientes/zurich.jpg"),
      },
      {
        title: "CONAB - Companhia Nacianal de Abastecimento - MG",
        src: require("../assets/img/clientes/conab.jpg"),
      },
      {
        title:
          "Empresa da Tecnologia da Informação e Comunicação do Município de São Paulo - PRODAM-SP S/A - SP",
        src: require("../assets/img/clientes/prodam.jpg"),
      },
      {
        title: "FUMSOFT Sociedade Mineira de Software - MG",
        src: require("../assets/img/clientes/fumsoft.jpg"),
      },
      {
        title: "Fundação Banco do Brasil - DF",
        src: require("../assets/img/clientes/fundacao.jpg"),
      },
      {
        title: "Fundação Getúlio Vargas - RJ",
        src: require("../assets/img/clientes/fgv.jpg"),
      },
      {
        title: "MGS - Minas Gerais Administração e Serviços S/A - MG",
        src: require("../assets/img/clientes/mgs.jpg"),
      },
      {
        title: "Ordem dos Advogados do Brasil - MG",
        src: require("../assets/img/clientes/oab.jpg"),
      },
      {
        title: "Secretaria do Estado de Educação de Goiás - GO",
        src: require("../assets/img/clientes/goias.jpg"),
      },
      {
        title: "SENAI - Serviço Nacional de Aprendizagem Industrial - MG",
        src: require("../assets/img/clientes/senai.jpg"),
      },
      {
        title: "Toshiba do Brasil S/A - Unidade Contagem - MG",
        src: require("../assets/img/clientes/toshiba.jpg"),
      },
      {
        title: "Cemig Distribuição S.A - MG",
        src: require("../assets/img/clientes/cemig.jpg"),
      },
      {
        title: "Nova Era Silicon S/A - MG",
        src: require("../assets/img/clientes/novaera.jpg"),
      },
      {
        title: "Rede Bandeirantes de Tv - MG",
        src: require("../assets/img/clientes/band.jpg"),
      },
    ];
  }
}
